import moment from 'moment';

export const formatDateTime = (dateString, format) => {
  if (!dateString) return '';
  return moment(dateString).format(format);
};

export const datesStartOfEndOf = (dateString, mode) => {
  if (!dateString) return '';
  if (mode === 'start') return moment(dateString).startOf('day');
  if (mode === 'end') return moment(dateString).endOf('day');
};

export const formatAuditValue = (value) => {
  if (value === null || value === undefined || value === '') return value;
  if (typeof value !== 'string') return value;
  const isoDateWithZonePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?(\[[^\]]+\])?$/;
  if (!isoDateWithZonePattern.test(value)) return value;
  const cleaned = value.replace(/\[[^\]]+\]$/, '');
  const parsed = moment(cleaned);
  if (!parsed.isValid()) return value;
  return parsed.format('YYYY-MM-DD HH:mm:ss');
};

export const convertIsoDatesInText = (text, format = 'DD/MM/YYYY HH:mm') => {
  if (!text) return text;
  const isoDatePattern = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?(?:\[[^\]]+\])?/g;
  return text.replace(isoDatePattern, (match) => {
    const cleaned = match.replace(/\[[^\]]+\]$/, '');
    const parsed = moment(cleaned);
    return parsed.isValid() ? parsed.format(format) : match;
  });
};

export const formatRoleName = (role) => {
  if (!role) return 'N/A';
  return (
    role
      .replace(/^ROLE_/, '')
      .split('_')
      .filter(Boolean)
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(' ') || role
  );
};
